<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/sys/initialize/initsupplierout/list'

export default {
  name: "initsupplierout",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {}
};
</script>